/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import { Button } from 'primereact/button';
import { defaultColors as defaultColorsKenya } from '../../../../../../../../../../utils/palleteKenya';
import { defaultColors as defaultColorsSenegal } from '../../../../../../../../../../utils/palleteSenegal';
import { defaultColors as defaultColorsZimbabwe } from '../../../../../../../../../../utils/palleteZimbabwe';
import { defaultColors as defaultColorsUganda } from '../../../../../../../../../../utils/palleteUganda';
import { defaultColors as defaultColorsNigeria } from '../../../../../../../../../../utils/palleteNigeria';
import { defaultColors as defaultColorsGuatemala } from '../../../../../../../../../../utils/palleteGuatemala';
import { defaultColors as defaultColorsMali } from '../../../../../../../../../../utils/palleteMali';
import { defaultColors as defaultColorsPhilippines } from '../../../../../../../../../../utils/palletePhilipines';
import { defaultColors as defaultColorsZambia } from '../../../../../../../../../../utils/palleteZambia';
import { defaultColors as defaultColorsEthiopia } from '../../../../../../../../../../utils/palleteEthiopia';
import { defaultColors as defaultColorsSudan } from '../../../../../../../../../../utils/palleteSudan';
import { defaultColors as defaultColorsBurkina } from '../../../../../../../../../../utils/palleteBurkinaFaso';
import { defaultColors as defaultColorsNiger } from '../../../../../../../../../../utils/palleteNiger';
import nineColorPallete from '../../../../../../../../../../utils/nineColorPallete';
import twelveColorPallete from '../../../../../../../../../../utils/twelveColorPallete';
import Actions from '../../../../../../../../../../reducer/actions';
import './styles.css';
import Translator from '../../../../../../../../../../components/Translator';

const Map = () => {
	const dispatch = useDispatch();

	const setWhereSelectedFeature = (payload) => dispatch({ type: Actions.SetWhereSelectedFeature, payload });

	const megapixelsGeoJson = useSelector((state) => state.megapixelsGeoJson);

	const whereFiltersSelections = useSelector((state) => state.whereFiltersSelections);

	const country = useSelector((state) => state.country);

	const [map, setMap] = useState(null);
	const [closeLegend, setCloseLegend] = useState(false);

	// const megapixels = { features: megapixelsJson.features, name: megapixelsJson.name, type: megapixelsJson.type };

	const mapRef = (element) => {
		setMap(element);
	};

	const defaultColors = (filters) => {
		switch (country.id) {
		case 'KEN': return defaultColorsKenya(filters);
		case 'SEN': return defaultColorsSenegal(filters);
		case 'ZWE': return defaultColorsZimbabwe(filters);
		case 'UGA': return defaultColorsUganda(filters);
		case 'NGA': return defaultColorsNigeria(filters);
		case 'GTM': return defaultColorsGuatemala(filters);
		case 'MLI': return defaultColorsMali(filters);
		case 'PHL': return defaultColorsPhilippines(filters);
		case 'ZMB': return defaultColorsZambia(filters);
		case 'ETH': return defaultColorsEthiopia(filters);
		case 'SDN': return defaultColorsSudan(filters);
		case 'BFA': return defaultColorsBurkina(filters);
		case 'NER': return defaultColorsNiger(filters);
		default: return defaultColorsKenya(filters);
		}
	};

	const featureClick = (feature, localLayer) => {
		const id = `${feature.properties.NAME_1} / ${feature.properties.NAME_2} / ${feature.properties.NAME_3}`;
		localLayer.on(
			{
				click(e) {
					setWhereSelectedFeature({ id, properties: e.target.feature.properties });

					map.eachLayer((item) => {
						if (item.options.id === 2) {
							map.removeLayer(item);
						}
					});
					const highlightLayer = L.geoJSON(e.target.feature, {
						pane: `pane-2`,
						id: 2,
						style: {
							fillOpacity: 0,
							weight: 4,
							color: 'black',
						},
						onEachFeature(feat, highlight) {
							highlight.on(
								{
									click(ev) {
										setWhereSelectedFeature({ id, properties: e.target.feature.properties });
									},
								}
							);
						},
					});
					map.addLayer(highlightLayer);
				},
			}
		);
	};

	useEffect(
		() => {
			if (!map) return;
			map.eachLayer((layer) => {
				if (layer.options.id === 1 || layer.options.id === 2) {
					map.removeLayer(layer);
				}
			});
			const layer = L.geoJSON(megapixelsGeoJson.features, {
				pane: `pane-1`,
				id: 1,
				style(feature) {
					// console.log(feature);
					const climateOrder = feature.properties.clim_cluster_short_label;
					const conflictLevel = feature.properties.conflict_clust_label;
					const filters = { conflict: '', climate: '', socioeconomic: '' };
					if (whereFiltersSelections.climate === '') {
						filters.climate = climateOrder;
					} else if (whereFiltersSelections.climate === climateOrder) {
						filters.climate = climateOrder;
					}
					if (whereFiltersSelections.conflict === '') {
						filters.conflict = conflictLevel;
					} else if (whereFiltersSelections.conflict === conflictLevel) {
						filters.conflict = conflictLevel;
					}
					if (!whereFiltersSelections.socioeconomic.length) {
						return defaultColors(filters);
					}
					let flag = false;
					whereFiltersSelections.socioeconomic.map((item) => {
						if (typeof feature.properties.ip_all_category === 'string') {
							if (feature.properties.ip_all_category.includes(item)) {
								flag = true;
							} 
						}
					});
					if (flag) {
						return defaultColors(filters);
					} 
					return { fillOpacity: 0, opacity: 0 };
					
					// return defaultColors(filters);
				},
				onEachFeature(feature, localLayer) {
					featureClick(feature, localLayer);
					// if (climateCluster === '' && conflictCluster === '') {
					// 	featureClick(feature, localLayer);
					// } if (climateCluster === '') {
					// 	if (feature.properties.conflict_clust_label === conflictCluster) {
					// 		featureClick(feature, localLayer);
					// 	}
					// } if (conflictCluster === '') {
					// 	if (feature.properties.clim_cluster_short_label === climateCluster) {
					// 		featureClick(feature, localLayer);
					// 	}
					// }
					// if (feature.properties.clim_cluster_short_label === climateCluster && feature.properties.conflict_clust_label === conflictCluster) {
					// 	featureClick(feature, localLayer);
					// }
				},
			});
			map.addLayer(layer);
		}, [map, whereFiltersSelections, megapixelsGeoJson]
	);

	//
	// useEffect(
	// 	() => {
	// 		setWhereSelectedFeature({});
	// 	}, [climateCluster, conflictCluster, reset]
	// );

	const onEachFeature = (feature, layer, property) => {
		// eslint-disable-next-line max-len
		layer.bindPopup(feature.properties[property], { closeButton: false, offset: L.point(0, -20), autoPan: false });
		layer.on('mouseover', () => { layer.openPopup(); });
		layer.on('mouseout', () => { layer.closePopup(); });
	};

	const boundsLayer = L.geoJSON(megapixelsGeoJson, {
		pane: `pane-0`,
		id: 0,
		style: {
			fillOpacity: 0,
			weight: 1,
			color: 'white',
		},
	});

	useEffect(
		() => {
			if (!map) return;

			map.createPane(`pane-0`);
			map.getPane(`pane-0`).style.zIndex = 401;
			map.createPane(`pane-1`);
			map.getPane(`pane-1`).style.zIndex = 498;
			map.createPane(`pane-2`);
			map.getPane(`pane-2`).style.zIndex = 499;
			map.fitBounds(boundsLayer.getBounds());
			map.setMaxBounds(boundsLayer.getBounds());
			map.zoomControl.setPosition('topleft');
			map.options.maxZoom = 14;
			map.options.minZoom = 6;
			map.options.zoomSnap = 0.25;
			map.options.zoomDelta = 0.25;
			map.options.wheelPxPerZoomLevel = 170;
			// map.setZoom(6);
			// map.addLayer(boundsLayer);
		}, [map, megapixelsGeoJson]
	);

	const resetZoom = () => {
		map.fitBounds(boundsLayer.getBounds());
	};

	const downloadData = () => {
		const x = megapixelsGeoJson;
		const url = window.URL.createObjectURL(
			// new Blob([JSON.stringify(dataSourcesMockData), JSON.stringify(methodsMockData), JSON.stringify(reportsMockData)], { type: 'text/json' })
			new Blob([JSON.stringify(x)], { type: 'text/json' })
		);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute(
			'download',
			'data.txt'
		);
		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);
	};

	const renderLegend = () => {
		let colors;
		switch (country.id) {
		case 'SEN': colors = nineColorPallete; break;
		case 'ZWE': colors = nineColorPallete; break;
		case 'SDN': colors = nineColorPallete; break;
		case 'BFA': colors = nineColorPallete; break;
		default: colors = twelveColorPallete; break;
		}
		const squares = [];
		let index = 0;
		while (index != colors.length - 1) {
			squares.push(<div className="square-size" style={{ background: colors[index] }} />);
			index += 3;
			if (index > colors.length - 1) {
				index -= (colors.length - 1);
			}
		}
		squares.push(<div className="square-size" style={{ background: colors[colors.length - 1] }} />);
		return squares;
	};

	return (
		<div className="map-component">
			<MapContainer scrollWheelZoom ref={mapRef}>
				<TileLayer
					attribution="Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
					url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}"
				/>
			</MapContainer>
			<div className="reset-zoom" role="button" tabIndex="0" aria-label="reset-zoom" onClick={resetZoom}>
				<i className="fa-duotone fa-house" />
			</div>
			{!closeLegend
				? (
					<div className="map-legend">
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
							{/* <Button onClick={() => setCloseLegend(true)}>	<i className="fa-solid fa-xmark" /></Button> */}
							<div style={{ display: 'flex', cursor: 'pointer' }} role="button" tabIndex="0" aria-label="close" onClick={() => setCloseLegend(true)}>
								<i className="fa-solid fa-xmark" />
							</div>
						</div>
						<div className="square-presentation">
							<div className="square" />
							<p>20 km<sup>2</sup></p>
						</div>
						<div className="color-pallete-wrap">
							<p><Translator text="Limited Conflict" /></p>
							<div>
								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
									{renderLegend()}
								</div>
								<p style={{ marginTop: '10px' }}><Translator text="Different conditions of climate" /></p>
							</div>

							<p><Translator text="High Conflict" /></p>
						</div>
						<div className="download-button">
							<Button label={<Translator text="Download Data" />} icon="fa-regular fa-down-to-bracket" onClick={downloadData} />
						</div>
					</div>
				) : (
					<div className="open-legend-btn" role="button" tabIndex="0" aria-label="info" onClick={() => setCloseLegend(false)}>
						<i className="fa-light fa-circle-info" />
					</div>

				)
			}
		</div>
	);
};

export default Map;
